module.exports = __webpack_public_path__ + "static/media/uav-icon-small.ab41da5d.webp";